import { createNewCart, getCart } from '@/shared/service/bc/graphql/cart';
import B3Request from '@/shared/service/request/b3Fetch';

export async function fetchCart() {
  const res = await getCart();
  return res?.data?.site?.cart;
}

const addCartLineItemsQuery = `mutation addCartLineItems($input: AddCartLineItemsInput!) {
  cart {
    addCartLineItems(input: $input) {
      cart {
        entityId
      }
    }
  }
}`;

export const addCartLineItems = async (variables: {
  input: {
    cartEntityId: string;
    data: {
      lineItems: Array<{
        quantity: number;
        productEntityId: number;
        variantEntityId?: number;
      }>;
    };
  };
}) => {
  await B3Request.graphqlBCProxy({
    query: addCartLineItemsQuery,
    variables,
  });
  return fetchCart();
};

const updateCartLineItemQuery = `mutation updateCartLineItem($updateCartLineItemInput: UpdateCartLineItemInput!) {
  cart {
    updateCartLineItem(input: $updateCartLineItemInput) {
      cart {
        entityId
      }
    }
  }
}`;

export async function updateItemQuantity(
  cartId: string,
  itemId: string,
  productId: number,
  quantity: number,
) {
  const data = {
    updateCartLineItemInput: {
      cartEntityId: cartId,
      lineItemEntityId: itemId,
      data: {
        lineItem: {
          quantity,
          productEntityId: productId,
        },
      },
    },
  };
  await B3Request.graphqlBCProxy({
    query: updateCartLineItemQuery,
    variables: data,
  });
  return fetchCart();
}

export async function removeItemFromCart(cartId: string, itemId: string) {
  await fetch(`/api/storefront/carts/${cartId}/items/${itemId}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  return fetchCart();
}

const deleteCartQuery = `mutation deleteCart($deleteCartInput: DeleteCartInput!) {
  cart {
    deleteCart(input: $deleteCartInput) {
      deletedCartEntityId
    }
  }
}`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteCart = async (data: any): Promise<any> =>
  B3Request.graphqlBCProxy({
    query: deleteCartQuery,
    variables: data,
  });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createCart = async (data: any): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return createNewCart(data).then((returnData: any) => {
    return returnData.data.cart.createCart.cart;
  });
};

export default {
  fetchCart,
  addCartLineItems,
  updateItemQuantity,
  removeItemFromCart,
  createCart,
  deleteCart,
};
